import * as React from 'react'
import Dialog from '@material-ui/core/Dialog'

import { Button, ButtonProps } from 'shared/components/button'
import { appWithStyles, AppWithStyles } from 'core/theme/utils/with-styles'
import { Flex } from 'shared/components/flex'
import cx from 'classnames';

import { styles } from './confirmation.styles'

export type ConfirmationProps = AppWithStyles<typeof styles> & {}

export type ButtonConfig = { 
  text: string; 
  variant?: ButtonProps['variant']; 
  className?: string;
};

type ConfirmationState = {
  open: boolean
  title: React.ReactNode
  question: React.ReactNode
  buttonsConfig?: {
    confirm?: ButtonConfig
    reject?: ButtonConfig
  }
  callback: (isConfirmed?: boolean) => void
}

let showConfirmationFn

export function showConfirmation(
  { title, question, buttonsConfig }: Partial<ConfirmationState>,
  callback: (isConfirmed: boolean) => void,
): void {
  showConfirmationFn({ title, question, buttonsConfig }, callback)
}

class ConfirmationComponent extends React.Component<
  ConfirmationProps,
  ConfirmationState
> {
  readonly state: ConfirmationState = {
    open: false,
    title: '',
    question: '',
    callback: (): void => {},
  }

  componentDidMount() {
    showConfirmationFn = this.show
  }

  private show = (
    { title, question, buttonsConfig }: Partial<ConfirmationState>,
    callback: (isConfirmed: boolean) => void,
  ): void => {
    this.setState({ title, question, buttonsConfig, callback, open: true })
  }

  private terminate = () => {
    this.state.callback(false)
    this.hide()
  }

  private hide = () => {
    this.setState({ open: false })
  }

  private confirm = () => {
    this.state.callback(true)
    this.hide()
  }

  render() {
    const { classes } = this.props
    const { open, title, question, buttonsConfig } = this.state

    return (
      <Dialog
        open={open}
        classes={{
          root: classes.root,
          paper: classes.paper,
        }}
        onClose={this.hide}
      >
        <Flex justify="center" classes={{ root: classes.title }}>
          {title}
        </Flex>
        <Flex justify="center" classes={{ root: classes.question }}>
          {question}
        </Flex>
        <Flex justify="center">
          <div>
            <Button
              classes={{ root: cx(classes.control, buttonsConfig?.reject?.className) }}
              text={buttonsConfig?.reject?.text || 'Cancel'}
              variant={buttonsConfig?.reject?.variant}
              onClick={this.terminate}
            />
            <Button
              classes={{ root: cx(classes.control, buttonsConfig?.confirm?.className) }}
              text={buttonsConfig?.confirm?.text || 'Yes'}
              variant={buttonsConfig?.confirm?.variant}
              onClick={this.confirm}
            />
          </div>
        </Flex>
      </Dialog>
    )
  }
}

export default appWithStyles(styles)(ConfirmationComponent)
